// extracted by mini-css-extract-plugin
export default {"testimonials":"Testimonials_testimonials__OEeAR"};